<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.SalesforceNetZeroCloudUsers') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <!-- <b-button variant="primary" @click="processSelectedUsers">
                <b-icon icon="check-square" class="icon-style"></b-icon>
              </b-button> -->
                        <b-button variant="primary" @click="$router.go(-1)">
                            <b-icon icon="arrow-left" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template #cell(actions)="{ item }">
                        <!-- Checkbox for selecting users -->
                        <input type="checkbox" :value="item.microsoft_user_id" v-model="selectedUsers" class="mr-2" />

                        <!-- Button with some margin-left for spacing -->
                        <b-button variant="light" class="ml-2"
                            @click="$router.push({ name: 'Inbox', params: { id: item.microsoft_user_id } })">
                            <b-icon variant="primary" icon="envelope" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <!-- Display Response Payload -->
                    <template #cell(response_payload)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.response_payload" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ key }}</strong> :-{{ value }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ formatDate(item.created_at) }}
                            </span>
                        </div>
                    </template>

                    <!-- Custom cell for billing_address -->
                    <template #cell(billing_address)="{ item }">
                        <div>
                            <!-- Attempt to parse billing_address JSON -->
                            <pre>{{ parseAndFormatJSON(item.billing_address) }}</pre>
                        </div>
                    </template>

                    <!-- Custom cell for shipping_address -->
                    <template #cell(shipping_address)="{ item }">
                        <div>
                            <!-- Attempt to parse shipping_address JSON -->
                            <pre>{{ parseAndFormatJSON(item.shipping_address) }}</pre>
                        </div>
                    </template>

                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null,
    integration_id: null
};

const COLUMN_STATE = (self) => [
    { key: 'actions', label: self.$t('title.actions') },
    { key: 'integration_id', label: self.$t('title.integration_id'), sortable: true },
    { key: 'annual_emissions_inventory_id', label: self.$t('title.annual_emissions_inventory_id'), sortable: true },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'year', label: self.$t('title.year'), sortable: true },
    { key: 'total_scope_1_emissions', label: self.$t('title.total_scope_1_emissions'), sortable: true },
    { key: 'total_scope_2_emissions', label: self.$t('title.total_scope_2_emissions'), sortable: true },
    { key: 'total_scope_3_emissions', label: self.$t('title.total_scope_3_emissions'), sortable: true },
    { key: 'total_emissions', label: self.$t('title.total_emissions'), sortable: true },
    { key: 'final_emission_in_tco2e', label: self.$t('title.final_emission_in_tco2e'), sortable: true }
];


export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    components: { Breadcrumbs },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
   
        parseAndFormatJSON(jsonString) {
            try {
                const obj = typeof jsonString === 'object' ? jsonString : JSON.parse(jsonString);
                // Format the JSON object for display.
                // You can customize this further to output a more formatted view.
                return JSON.stringify(obj, null, 2);
            } catch (error) {
                // In case of error, return the original string.
                return jsonString;
            }
        }
    },
    computed: {
        listUrl() {
            const id = this.$route.params.id || '';
            return `admin/salesforce/annual-emissions-inventory/${id}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>